export const isEmptyStr = (value: null | undefined | string) => {
  return value === undefined || value === null || value.trim() === "";
};

export const notJson = (value: null | undefined | string) => {
  if (!value) return true;
  return value.indexOf("[") == -1 && value.indexOf("{") == -1;
};

/** Strips HTML tags/entities for plain-text display (e.g. accordion titles). */
export const stripHtmlToPlainText = (
  html: string | null | undefined
): string => {
  if (!html) {
    return "";
  }

  return html
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, " ")
    .trim();
};
